export default __webpack_public_path__ + "static/media/logo_airtiketa.6be21523.svg";